/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var style = _interopDefault(require('../mixin/style'));
var stylesContainer = _interopDefault(require('../mixin/styles-container'));
var assert = require('../util/assert');
var log = require('../util/log');
var minilo = require('../util/minilo');
var mergeDescriptors = _interopDefault(require('../util/multi-merge-descriptors'));
var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));

var props = {
  /**
   * @type {function(): ol.StyleFunction}
   */
  factory: {
    type: Function,
    required: true
  }
};

var computed = {
  styleFunc: function styleFunc() {
    var func = this.factory();
    if (!minilo.isFunction(func)) {
      if (process.env.NODE_ENV !== 'production') {
        log.warn('Factory returned a value not of Function type, fallback style will be used');
      }
      func = minilo.noop;
    }

    return func;
  }
};

var methods = {
  /**
   * @return {ol.StyleFunction}
   * @protected
   */
  createStyle: function createStyle() {
    assert.hasMap(this);
    // user provided style function
    var providedStyleFunc = this.styleFunc;
    // fallback style function made from inner style containers
    var fallbackStyleFunc = this.createStyleFunc();

    return function __styleFunc(feature, resolution) {
      var styles = providedStyleFunc(feature, resolution);
      // not empty or null style
      if (styles === null || Array.isArray(styles) && styles.length) {
        return styles;
      }
      return fallbackStyleFunc(feature, resolution);
    };
  },

  /**
   * @return {void}
   * @protected
   */
  mount: function mount() {
    this.$stylesContainer && this.$stylesContainer.addStyle(this);
  },

  /**
   * @return {void}
   * @protected
   */
  unmount: function unmount() {
    this.$stylesContainer && this.$stylesContainer.removeStyle(this);
  },

  /**
   * @returns {Object}
   * @protected
   */
  getServices: function getServices() {
    var vm = this;

    return mergeDescriptors(style.methods.getServices.call(this), {
      get stylesContainer() {
        return vm;
      }
    });
  },

  /**
   * Overrides stylesContainer `setStyle` method
   * @param {Array<{ style: ol.style.Style, condition: (function|boolean|undefined) }>|ol.StyleFunction|Vue|undefined} styles
   * @return {void}
   */
  setStyle: function setStyle(styles) {
    if (styles !== this._styles) {
      // simply save all inner styles and
      // use them later in style function as fallback
      this._styles = styles;
      this.scheduleRefresh();
    }
  },

  /**
   * @return {Promise}
   */
  refresh: function refresh() {
    // recreate style
    return this.recreate();
  }
};

var watch = {
  factory: function factory() {
    this.scheduleRefresh();
  }
};

var Style = {
  name: 'vl-style-func',
  mixins: [style, stylesContainer],
  props: props,
  computed: computed,
  methods: methods,
  watch: watch,
  stubVNode: {
    empty: false,
    attrs: function attrs() {
      return {
        class: this.$options.name
      };
    }
  }
};

/**
 * @alias module:style-func
 */
var index = {
  /**
   * @alias module:style-func/style
   */
  Style: Style,
  /**
   * @param {Vue} Vue
   * @param {VueLayersOptions} [options]
   */
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    options = minilo.pick(options, 'dataProjection');
    _Object$assign(Style, options);

    Vue.component(Style.name, Style);
  }
};

module.exports = index;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/style-func/index.js
// module id = 1490
// module chunks = 1